
        import wasmModule from "/Users/PaloTropiHlouposti/Workspace/gc/sdk/node_modules/@galacticcouncil/math-lbp/hydra_dx_wasm_bg.wasm";

        
        // Import from JS modules
        

        // Build the WASM import object
        const imports = {
            
        };

        async function loadWasm(module, imports) {
            if (typeof module === 'string') {
                const moduleRequest = await fetch(module);
                if (typeof WebAssembly.instantiateStreaming === 'function') {
                    try {
                        return await WebAssembly.instantiateStreaming(moduleRequest, imports);
                    } catch (e) {
                        if (moduleRequest.headers.get('Content-Type') != 'application/wasm') {
                            console.warn(e);
                        } else {
                            throw e;
                        }
                    }
                }
                module = await moduleRequest.arrayBuffer();
            }
            return await WebAssembly.instantiate(module, imports);
        }

        export const { instance, module } = await loadWasm(wasmModule, imports);

        export const memory = instance.exports.memory;
export const calculate_pool_trade_fee = instance.exports.calculate_pool_trade_fee;
export const get_spot_price = instance.exports.get_spot_price;
export const calculate_out_given_in = instance.exports.calculate_out_given_in;
export const calculate_in_given_out = instance.exports.calculate_in_given_out;
export const calculate_linear_weights = instance.exports.calculate_linear_weights;
export const __wbindgen_add_to_stack_pointer = instance.exports.__wbindgen_add_to_stack_pointer;
export const __wbindgen_malloc = instance.exports.__wbindgen_malloc;
export const __wbindgen_realloc = instance.exports.__wbindgen_realloc;
export const __wbindgen_free = instance.exports.__wbindgen_free;
    